import axios from '@/assets/http';

export default {
    getInfo(params) {
        return axios.get(`/api/v1/user/${params.id}`);
    },
    getUserInfo(params) {
        return axios.get(`/api/user/getUserInfo`, {params: params});
    },
    
}
